<template>
  <v-container>
    <v-stepper
      alt-labels
      class="mt-12 d-none d-md-block"
      :value="currentStatusId"
      id="md-tracker"
    >
      <v-stepper-header
        v-if="this.steps"
        :style="
          currentStatusId >= 11 && sampleStatus ? 'padding-bottom: 50px;' : ''
        "
      >
        <template v-for="(step, key) in steps">
          <v-stepper-step
            :step="step.id"
            :key="key"
            :complete="
              step.id < currentStatusId && currentStatusId < 11 && sampleStatus
            "
          >
            {{ step.title }}
          </v-stepper-step>
          <v-divider
            v-if="key !== steps.length - 1"
            :key="key + step"
          ></v-divider>
        </template>
        <div>
          <v-chip
            class="status-chip"
            color="#B6B6B6"
            v-if="currentStatusId >= 11 && sampleStatus"
          >
            <v-chip color="#DA570B" class="inner-chip">
              <div
                style="display: flex; align-items: center; width: 100%; justify-content: space-between;"
              >
                <img src="@/assets/chip-close.svg" alt="Help Icon" />
                <p style="margin-top: 15px; margin-left: 10px;">
                  {{ currentStatusTitle }}
                </p>
              </div>
            </v-chip>
            <div
              v-if="notes"
              style="margin-left: 0.5rem; font-weight: 500; font-size: 16px;"
            >
              :{{ notes }}
            </div>
          </v-chip>
        </div>
      </v-stepper-header>
    </v-stepper>
    <v-stepper
      alt-labels
      vertical
      class="d-block d-md-none"
      :value="currentStatusId"
      id="sm-tracker"
    >
      <template v-for="(step, key) in steps">
        <v-stepper-step
          :step="step.id"
          :key="key"
          :complete="step.id < currentStatusId"
        >
          {{ step.title }}
        </v-stepper-step>
        <v-divider
          v-if="key !== steps.length - 1"
          :key="key + step"
        ></v-divider>
      </template>
    </v-stepper>
    <v-row class="mt-2">
      <v-col>
        <v-btn color="red" @click="close" dark>Exit</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "StepIndicator",
  props: {
    steps: {},
    currentStatusId: {},
    sampleStatus: {
      type: Boolean,
      default: false
    },
    currentStatusTitle: {
      type: String,
      default: ""
    },
    notes: {
      type: String,
      default: ""
    }
  },
  methods: {
    close() {
      this.$emit("close-dialog");
    }
  }
};
</script>

<style scoped>
.stepper-container {
  position: relative;
}

.status-chip {
  position: absolute;
  bottom: 10px;
  left: 2.7rem;
  z-index: 10;
  height: 45px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  padding: 4px 20px;
}

.inner-chip {
  position: relative;
  color: #fff;
}

#md-tracker .v-divider {
  border-width: medium;
}
.v-stepper__step--complete + hr {
  background-color: #006940;
}
#md-tracker .v-stepper__step {
  font-size: 12px !important;
}
</style>
